export const lazyBg = () => {
  var lazyBackgrounds = [].slice.call(document.querySelectorAll("[data-bg]"));

  if ("IntersectionObserver" in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const bg = entry.target.dataset.bg;
          entry.target.style.backgroundImage = `url(${bg})`
          entry.target.classList.add('loaded')
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(lazyBackground => {
      if(!lazyBackground.classList.contains('observing')){
        lazyBackground.classList.add('observing')
        lazyBackgroundObserver.observe(lazyBackground)
      }
    });
  }
}